import { createAction } from '@reduxjs/toolkit'

export resetVisualizationStateToDefault = createAction('timeVisualization/resetVisualizationStateToDefault')
export setUseEndDateAttribute = createAction('timeVisualization/useEndDateAttributeSet')
export setSelectedAttribute = createAction('timeVisualization/selectedAttributeSet')
export setSelectedEndAttribute = createAction('timeVisualization/selectedEndAttributeSet')
export setStepSize = createAction('timeVisualization/stepSizeSet')
